<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-form ref="form" v-if="details.plate">
                        <v-card-title>
                            <span class="title-modal">Sair da Vaga</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="3">
                                        <v-text-field
                                            class="input-activation"
                                            label="Veículo"
                                            readonly
                                            v-model="details.plate">
                                            @keyup.enter="validateActivation()"
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <div class="flex-grow-1 text-right">
                                <v-btn class="btn-cancel" @click.prevent="closeDialog()">Cancelar</v-btn>
                                <v-btn class="btn-confirm" @click.prevent="validateActivation()">Sair da Vaga</v-btn>
                            </div>
                        </v-card-actions>
                        <v-dialog v-model="confirm" persistent max-width="400">
                            <v-card :loading="loading">
                                <v-card-title>
                                    <span class="title-modal">
                                        Confirmação
                                    </span>
                                </v-card-title>
                                <v-card-text>
                                    Você tem certeza que deseja sair da vaga para este veículo?
                                    <div class="resume-action">
                                        <div v-if="myVehicle.activation !== undefined
                                        && myVehicle.activation !== null
                                        && myVehicle.activation.time !== undefined
                                        && myVehicle.pending_notifications !== null
                                        && myVehicle.pending_notifications !== 0"
                                        >
                                            <v-alert class="text-center" type="error" color="#e72c1f">
                                                Atenção! Este veículo possui {{ myVehicle.pending_notifications }} irregularidade(s) pendente(s) de pagamento.
                                            </v-alert>
                                        </div>
                                        <h6><span>Veículo: </span> {{ details.plate }}</h6>
                                    </div>
                                </v-card-text>
                                <v-col cols="12">
                                    <v-alert type="error" color="#e72c1f" v-if="errorActivation !== null">
                                        {{ errorActivation }}
                                    </v-alert>
                                </v-col>
                                <v-card-actions>
                                    <div class="flex-grow-1 text-right">
                                        <v-btn class="btn-cancel" @click.prevent="confirm = false">Cancelar</v-btn>
                                        <v-btn class="btn-confirm" text @click.prevent="leaveParking()">Sair da Vaga</v-btn>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-form>
                    <v-form ref="form" v-else>
                        <v-card-title>
                            <span class="title-modal">Sair da vaga</span>
                        </v-card-title>
                        <v-card-actions>
                            <div class="flex-grow-1 text-right">
                                <v-btn class="btn-cancel" @click.prevent="closeDialog()">Fechar</v-btn>
                            </div>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>
        <v-snackbar
            v-model="message_success"
            :color="'success'"
            :multi-line="true"
            :right="true"
            :timeout="2000"
            :top="true"
            class="snackbar-success"
        >
            <span><i class="fas fa-check mr-2"></i> Operação realizada com sucesso!</span>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: [
        'vehicle'
    ],
    name: "LeaveParking",
    data: function () {
        return {
            loading: false,
            plates: [],
            wallets: [],
            myVehicle: {activation: {time: 0}},
            message_success: false,
            details: {},
            confirm: false,
            dialog: false,
            errorActivation: null,
            activation: {
                wallet: {
                    name: null,
                },
                product: {
                    price: null
                },
            },
        }
    },
    mounted() {
        axios.get('/api/users/driver/me/plate').then(res => {
            this.plates = res.data.data;
        });

        this.loading = true;
        axios.get('/api/users/driver/me/wallet').then(response => {
          this.wallets = response.data;
          this.activation.wallet = this.wallets[0];
          this.loading           = false;
        });
    },
    methods: {
        closeDialog: function () {
            this.$emit('dialog', false);
            this.dialog = false;
        },
        validateActivation: function () {
          this.plates.forEach(vehicle => {
              if (vehicle.plate === this.details.plate.toUpperCase()) {
                  this.myVehicle = vehicle;
              }
          });
          this.confirm = true;
          this.errorActivation = null;
        },
        getLastDetail(){
          return this.details.activation.details[this.details.activation.details.length-1];
        },
        leaveParking: function () {
            this.loading = true;
            axios.get('/api/transaction/devolution/' + this.getLastDetail().transaction_id).then(res => {
                if (res) {
                    this.message_success = true;
                    setTimeout(function () {
                        location.reload()
                    }, 1000);
                }
            }).catch(error => {
                this.errorActivation =
                    error.response.data.message
                    || 'Ocorreu um erro. Tente novamente.';
                this.loading         = false;
            });
        }
    },
    watch: {
        'vehicle': {
            immediate: true,
            deep: true,
            handler() {
                if (this.vehicle !== false) {
                    this.details = this.vehicle;
                    this.dialog  = true;
                }
            }
        }
    },
    computed: {
        advancedWalletOptions: function () {
            return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
        },
        buyCredits() {
            return process.env.VUE_APP_BUY_CREDITS;
        },
        showWallets() {
            return process.env.VUE_APP_SHOW_WALLETS;
        },
        name: function () {
            return process.env.VUE_APP_NAME;
        },
    }
}
</script>

<style scoped>
@media only screen and (max-width: 500px) {
    .btn-confirm, .btn-cancel {
        width: 100%;
        margin: 5px 0 !important;
        padding: 0;
    }
}

</style>
